import { DefaultModelProperty, LabelValue } from '../standard'
import CoherentScreen from './coherent-screen-model'
import coherentScreenProperties from './coherentScreen-properties'
import { CoherentScreenProperties } from './coherentScreen-property-definitions'

export async function OnEvents(
  eventType: string,
  form: CoherentScreen,
  property: CoherentScreenProperties,
): Promise<CoherentScreen> {
  switch (eventType) {
    case 'change':
      return await change(property, form)

    default:
      break
  }
  return form
}
export function IsDisabled(property: CoherentScreenProperties): boolean {
  switch (property) {
    default:
      return false
  }
}

export function IsVisible(property: CoherentScreenProperties): boolean {
  switch (property) {
    case CoherentScreenProperties.OrderedReferenceList:
      return false
    case CoherentScreenProperties.CuratedMediaLists:
      return false
    case CoherentScreenProperties.CuratedSeriesLists:
      return false
    case CoherentScreenProperties.Owner:
      return false
    case CoherentScreenProperties.Id:
      return false
    case CoherentScreenProperties.Created:
      return false
    case CoherentScreenProperties.Updated:
      return false
    case CoherentScreenProperties.Deleted:
      return false
    case CoherentScreenProperties.Version:
      return false
    case 'lastUpdatedBy':
      return false
    case 'highlightSeriesId':
      return false
    case 'processedSeries':
      return false
    case 'processedMedia':
      return false
    default:
      return true
  }
}
async function change(
  property: CoherentScreenProperties,
  value: CoherentScreen,
): Promise<CoherentScreen> {
  switch (property) {
    default:
      return value
  }
  return value
}
function getModelProperties(): DefaultModelProperty<CoherentScreenProperties>[] {
  return coherentScreenProperties as DefaultModelProperty<CoherentScreenProperties>[]
}
export function GetPageProperties(): DefaultModelProperty<CoherentScreenProperties>[] {
  function getPagePropertyPosition(property: string) {
    switch (property) {
      default:
        return 20
    }
  }
  return AssignUIComponent(
    getModelProperties()
      .filter((x: DefaultModelProperty<CoherentScreenProperties>) => {
        return getPagePropertyPosition(x.name) !== -1
      })
      .sort((a, b) => {
        return getPagePropertyPosition(a.name) - getPagePropertyPosition(b.name)
      })
      .map((v: DefaultModelProperty<CoherentScreenProperties>) => {
        return v
      }),
  )
}

export function DropdownOptions(
  property: CoherentScreenProperties,
): LabelValue<any>[] {
  switch (property) {
    default:
      return []
      break
  }
  return []
}
export function IsRequired(property: CoherentScreenProperties): boolean {
  switch (property) {
    case CoherentScreenProperties.OrderedReferenceList:
      return false
    case CoherentScreenProperties.CuratedMediaLists:
      return false
    case CoherentScreenProperties.CuratedSeriesLists:
      return false
    case CoherentScreenProperties.Owner:
      return false
    case CoherentScreenProperties.Id:
      return false
    case CoherentScreenProperties.Created:
      return false
    case CoherentScreenProperties.Updated:
      return false
    case CoherentScreenProperties.Deleted:
      return false
    case CoherentScreenProperties.Version:
      return false
    default:
      return true
  }
}
export function AssignUIComponent(
  properties: DefaultModelProperty<CoherentScreenProperties>[],
): DefaultModelProperty<CoherentScreenProperties>[] {
  return properties.map(
    (modelProperty: DefaultModelProperty<CoherentScreenProperties>) => {
      switch (modelProperty.name) {
        default:
          break
      }
      return modelProperty
    },
  )
}
